import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Layout } from 'diwo-layouts';
import { API } from '../API/API';
import Home from '../page/Home/Home';
import Forbidden from '../page/Shared/Forbidden';
import ComingSoon from '../page/Shared/ComingSoon';
import ExtraType from '../page/OrganizationSettings/BasicInfo/ExtraType/ExtraType';
import HRExtra from '../page/OrganizationSettings/BasicInfo/HRExtra/HRExtra';
import HRDeduction from '../page/OrganizationSettings/BasicInfo/HRDeduction/HRDeduction';
import Login from '../page/Login/Login';
import NotFound from '../page/Shared/NotFound';
import PasswordChange from '../page/UserMenu/PasswordChange';
import Employee from '../page/HRSuite/Employee/Employee';
import Report from '../page/Report/Report';
import UserList from '../page/OrganizationSettings/User/UserList/UserList';
import CompanyList from '../page/OrganizationSettings/Company/CompanyList';
import PrivateRoute from '../components/PrivateRoute/PrivateRoute';
import HRSuite from '../page/HRSuite/HRSuite';
import UpdEmpEmplHist from '../page/UpdEmpEmplHist/UpdEmpEmplHist';
import Market from '../page/Market/Market';
import MarketDtl from '../page/Market/Dtl/MarketDtl';
import EmailVerify from '../page/UserMenu/EmailVerify';
import ExcelImportEmp from '../page/ExcelImportEmp/ExcelImportEmp';
import DiwoAI from '../page/ChatGPT/DiwoAI';

const MainNav = (props) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [isPasswordChange, setIsPasswordChange] = useState(false);
    const [isVerifyPassword, setIsVerifyPassword] = useState(false);
    const [userMenu, setUserMenu] = useState([]);
    const [feedbackUnixId, setFeedbackUnixId] = useState();
    const [feedbackPage, setFeedbackPage] = useState();

    useEffect(() => {
        if (props?.userInfo?.emailverificationstatus != "Verified") {
            setUserMenu([{
                key: '2',
                label: (
                    <div
                        onClick={() => {
                            setIsVerifyPassword(true);
                        }}>
                        Имэйл баталгаажуулах
                    </div>
                )
            }]);
        } else {
            setUserMenu([]);
        }
    }, [props?.userInfo?.emailverificationstatus]);

    const onFeedback = async (pId, pType, pValue) => {
        if (pValue) {
            await API.post("/api/humanresource/Organization/setFeedback?id=" + pId + "&feedbacktype=" + pType + "&feedbackvalue=" + pValue + "&pageurl=" + (feedbackPage ? feedbackPage : window?.location?.pathname)).then(response => {
            });
            setFeedbackPage();
        }
    }

    if (!props?.userInfo?.accesstoken) {
        return (
            <Login />
        );
    }

    if (location.pathname?.indexOf("/pr/") >= 0) {
        return (
            <Layout
                navigate={navigate}
                location={location}
                pathname={location.pathname}
                userInfo={props?.userInfo}
                onPasswordChange={() => { setIsPasswordChange(true); }}
                onFeedback={onFeedback}
                feedbackUnixId={feedbackUnixId}
            >
            </Layout>
        );
    }

    return (
        <Layout
            navigate={navigate}
            location={location}
            pathname={location.pathname}
            userInfo={props?.userInfo}
            userMenu={userMenu}
            onPasswordChange={() => { setIsPasswordChange(true); }}
            onFeedback={onFeedback}
            feedbackUnixId={feedbackUnixId}
        >
            <Routes>
                <Route
                    path={"/hrsuite"}
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <HRSuite />
                        </PrivateRoute>
                    } />
                <Route
                    path={"/empemplhist"}
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <UpdEmpEmplHist />
                        </PrivateRoute>
                    } />
                <Route
                    path='/hrsuite/employee/:empid'
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <Employee />
                        </PrivateRoute>
                    } />
                <Route
                    path='/hrsuite/settings/granttype'
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <ExtraType />
                        </PrivateRoute>
                    } />
                <Route
                    path='/hrsuite/settings/grant'
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <HRExtra />
                        </PrivateRoute>
                    } />
                <Route
                    path='/hrsuite/settings/deduction'
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <HRDeduction />
                        </PrivateRoute>
                    } />
                <Route
                    path={"/excelimportemp"}
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <ExcelImportEmp setFeedbackUnixId={setFeedbackUnixId} setFeedbackPage={setFeedbackPage} />
                        </PrivateRoute>
                    } />
                <Route
                    path='/hrsuite/settings/users'
                    element={
                        <PrivateRoute roles={["HR", "ADMINISTRATOR", "ORGADMIN"]}>
                            <UserList />
                        </PrivateRoute>
                    } />
                <Route
                    path='/hrsuite/settings/company'
                    element={
                        <PrivateRoute roles={["ADMINISTRATOR"]}>
                            <CompanyList />
                        </PrivateRoute>
                    } />
                <Route
                    path={"/hrsuite/report/*"}
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <Report />
                        </PrivateRoute>
                    } />
                <Route
                    path={"/hrsuite/ai"}
                    element={
                        <PrivateRoute roles={["HR", "PAYROLL", "MANAGER"]}>
                            <DiwoAI setFeedbackUnixId={setFeedbackUnixId} />
                        </PrivateRoute>
                    } />
                <Route path='/hrsuite/home' element={<DiwoAI />} />
                <Route path='/change' element={<PasswordChange />} />
                <Route path="/forbidden" element={<Forbidden />} />
                <Route path="/hrsuite/market" element={<Market />} />
                <Route path="/hrsuite/market/:id" element={<MarketDtl />} />
                <Route path="/hrsuite/social" element={<ComingSoon type="social" />} />
                <Route path="/hrsuite/chat" element={<ComingSoon message="chat" />} />
                <Route path="/" element={<Navigate to="/hrsuite/home" />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <PasswordChange isOpen={isPasswordChange} onClick={() => { setIsPasswordChange(false); }} />
            <EmailVerify isOpen={isVerifyPassword} onClick={() => { setIsVerifyPassword(false); }} />
        </Layout>
    );
}

export default MainNav;